import SearchParams from "../init/searchparams";
import { getValueAtPath, isPlainObject, withProperties } from "../utils";
import getChargeData from "../init/chargedata";

const MUTABLE_DATA = 1;
const USER_MUTABLE_DATA = 2;

const CHARGE_DATA_FIELDS = {
  amount: MUTABLE_DATA,
  custom_campaign_id: 0,
  charge_type: 0,
  country: MUTABLE_DATA,
  currency: MUTABLE_DATA,
  "customer_phone::phone": MUTABLE_DATA | USER_MUTABLE_DATA,
  cycle: 0,
  device_fingerprint: 0,
  email: 0,
  custom_pwbt_expiry: 0,
  custom_narration: 0,
  firstname: 0,
  ip: 0,
  lastname: 0,
  meta: MUTABLE_DATA,
  modalauditid: MUTABLE_DATA,
  payment_page: 0,
  payment_plan: 0,
  payment_type: MUTABLE_DATA,
  PBFPubKey: 0,
  redirect_url: 0,
  subaccounts: 0,
  transaction_charge: 0,
  transaction_charge_type: 0,
  "txRef::txref": 0,
  QUERY_STRING_DATA: 0,
  merchant_vat_amount: 0
};

let BASE_CHARGE_DATA;
let shouldRefresh = true;

function refreshBaseChargeData() {
  return getChargeData().then(chargeData => {
    const $chargeData = isPlainObject(chargeData) ? chargeData : {};
    const $baseData = Object.create(null);

    shouldRefresh = !Object.isFrozen($chargeData);

    Object.keys(CHARGE_DATA_FIELDS).forEach(field => {
      let lookupField;

      [ field, lookupField = field ] = field.split('::');

      const value = lookupField === 'QUERY_STRING_DATA'
        ? SearchParams.raw
        : $chargeData[lookupField] || undefined;

      withProperties($baseData, { [field]: value });

      if (field === 'custom_pwbt_expiry') {
        let value = SearchParams.get('custom_pwbt_expiry');
        const searchParamFields = SearchParams.raw;
        if (!value) {
          value = searchParamFields['bank_transfer_expiry'];
        }

        withProperties($baseData, { 'expires': value });
      }

      if (field === 'custom_narration') {
        let value = SearchParams.get('custom_narration');
        if (value) withProperties($baseData, { 'narration': value });
      }

      if (field === 'custom_campaign_id') {
        let campaignId = getValueAtPath(chargeData, 'campaign.campaign_id') || null;

        withProperties($baseData, { 
          'campaign_id': campaignId,
          'is_discounted': campaignId !== null ? 1 : 0,
        });
      }

      // set customer_phone to phonenumber
      if (field === 'customer_phone') {
        let phonenumber = SearchParams.get('customer_phone');
        if (phonenumber) withProperties($baseData, { 'phonenumber': phonenumber });
      }
    });

    return (BASE_CHARGE_DATA = Object.freeze($baseData));
  });
}

function getBaseChargeData() {
  return Promise.resolve(
    shouldRefresh === true
      ? refreshBaseChargeData.call(this)
      : BASE_CHARGE_DATA || refreshBaseChargeData.call(this)
  ).then(data => (data || Object.freeze(Object.create(null))));
}

export {
  CHARGE_DATA_FIELDS,
  getBaseChargeData,
  refreshBaseChargeData
};

export default function __aggregateChargeData__(data) {
  return getBaseChargeData.call(this)
    .then(($baseData) => {
      data = isPlainObject(data) ? data : {};
      const $newData = { ...$baseData };
      const FIELDS = Object.keys(CHARGE_DATA_FIELDS);

      Object.keys(data).forEach(field => {
        const lookupField = FIELDS.find(($field) => RegExp(`/^${field}(?:::.+)?$/`).test($field));

        if (!lookupField || (CHARGE_DATA_FIELDS[lookupField] & MUTABLE_DATA)) {
          $newData[field] = data[field];
        }
      });

      return $newData;
    });
}
